import { Link } from "react-router-dom";
import { useMarket } from "./MarketProvider";
import { useIsMobile, useV3 } from "./useV3";
import { fill } from "./strings";
import { Close, Flag } from "./Icons";

/* "It looks like you are in Saudi Arabia — browse that market?"
 *
 * A SUGGESTION. The design's own note is «never a redirect»: a visitor who
 * asked for /eg/ gets /eg/, and this offers the other door rather than
 * walking them through it. Dismissing writes a localStorage flag, so it is
 * asked once and never again on that device.
 *
 * The guess is the browser's IANA timezone against `countries.timezone` --
 * no IP lookup and no third party. See MarketProvider for why.
 */
export function MarketSuggestion() {
  const { suggested, dismissSuggestion } = useMarket();
  const { s, ar } = useV3();
  const mobile = useIsMobile();

  if (!suggested) return null;
  const name = ar ? suggested.nameAr : suggested.nameEn;
  const href = `/${suggested.slug}/`;

  return (
    <div data-component="market-suggestion" className="sq-market-suggestion" role="status">
      <Flag code={suggested.code} />
      {/* Mobile says less because the bar is one line on a 390 screen; both
          wordings are the design's own, from the -390 and -1440 files. */}
      <span>
        {mobile ? fill(s.marketSuggestion.lead, { market: name })
          : fill(s.marketSuggestion.leadLong, { market: name })}{" "}
        <Link to={href} className="sq-link--underline">
          {mobile ? fill(s.marketSuggestion.goShort, { market: name })
            : fill(s.marketSuggestion.go, { slug: suggested.slug })}
        </Link>
      </span>
      <button type="button" className="sq-btn sq-btn--ghost sq-btn--icon"
        aria-label={s.marketSuggestion.close} onClick={dismissSuggestion}>
        <Close />
      </button>
    </div>
  );
}
